import script from "./safeguard.vue?vue&type=script&setup=true&lang=js"
export * from "./safeguard.vue?vue&type=script&setup=true&lang=js"

import "./safeguard.vue?vue&type=style&index=0&id=065d55f0&lang=scss&scoped=true"
import "./safeguard.vue?vue&type=style&index=1&id=065d55f0&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065d55f0"]])

export default __exports__